'use client'

import cleanStoredInfo from '@/useCases/auth/cleanStoredInfo'

const handleLogout = async () => {
  await cleanStoredInfo()
  return true
}

export default handleLogout
